export default __webpack_public_path__ + "static/media/play.47acbf8f.svg";